var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/profile-picture") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,11.4615385 C13.8225397,11.4615385 15.3,10.0150738 15.3,8.23076923 C15.3,6.44646465 13.8225397,5 12,5 C10.1774603,5 8.7,6.44646465 8.7,8.23076923 C8.7,10.0150738 10.1774603,11.4615385 12,11.4615385 Z M10.8772503,12.5384615 L13.1227497,12.5384615 C15.0154795,12.5384615 16.6323552,13.9033454 16.95,15.7692308 L17.0029798,16.080441 C17.2346959,17.4415703 16.3191256,18.7328265 14.9579963,18.9645426 C14.8193892,18.9881388 14.6790385,19 14.5384372,19 L9.46156277,19 C8.08085089,19 6.96156277,17.8807119 6.96156277,16.5 C6.96156277,16.3593987 6.97342396,16.2190481 6.99702017,16.080441 L7.05,15.7692308 C7.36764477,13.9033454 8.98452048,12.5384615 10.8772503,12.5384615 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/profile-picture",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profile-picture.66169b6bd2d82fca1971b26fddd90428.svg";
export { ForwardRef as ReactComponent };